import { PermissionsByProStatus } from '../types';

interface ExtractPermissionByProStatusParams {
  isPro: boolean;
  permissionsByProStatus: PermissionsByProStatus;
}

export function extractPermissionByProStatus({
  isPro,
  permissionsByProStatus,
}: ExtractPermissionByProStatusParams) {
  const { pro, free } = permissionsByProStatus;
  return isPro ? pro : free;
}
